<template>
  <div class="common_header" :class="[
    { 'common_header_increase': tabsList.length > 1 },
    { 'common_header_narrow': !breadcrumbShow }
  ]">
    <div class="wrap" :class="{ 'isCollapse': menuCollapseFlag }">
      <div class="top" v-if="breadcrumbShow">
        <div class="breadcrumb">
          <i class="iconfont icon-1 homeIcon" @click="pageJump({ path: '/home' })" />
          <span v-for="(item, index) in breadcrumbList" :key="index">
            <i /><span @click="pageJump(item)">{{ item.name }}</span>
          </span>
        </div>
        <div class="explain" v-if="explain.text">
          <i class="iconfont icon-tishi-icon" />{{ explain.text }}<span @click="showDialog()">{{
              $t('general.ctView')
          }}</span>
        </div>
        <div class="buttons" v-if="tabsList.length <= 1">
          <slot name="buttons" />
        </div>
      </div>
      <div class="bottom" v-if="tabsList.length > 1">
        <div class="tabs">
          <div class="tabsPane" v-for="(item, index) in tabsList" :key="index"
            v-show="!item.hidden"
            :class="tabsActiveName === item.name ? 'active' : ''" @click="tabsClickHandler(item)">
            <span>{{ item.label }}</span>
            <span v-show="tabsQuantityShow && item.quantity" class="tipsNum"
              :class="item.quantity > 9 ? 'widening' : ''">
              <span>{{ item.quantity > 99 ? '99+' : item.quantity }}</span>
            </span>
          </div>
          <!-- <el-tabs
            v-model="tabsActiveName"
            @tab-click="handleTabsClick"
            type="border-card"
            slot="tabs"
          >
            <el-tab-pane
              v-for="(item, index) in tabsList"
              :key="index"
              :label="item.label"
              :name="item.name"
            />
          </el-tabs> -->
        </div>
        <div class="buttons">
          <slot name="buttons" />
        </div>
      </div>
    </div>
    <div class="occupyingElement" />
    <el-dialog class="ruleDialog" :title="$t('general.AppRules')" :visible.sync="dialogVisible" width="44%">
      <div style="white-space: pre-line;" v-html="explain.content" />
    </el-dialog>
  </div>
</template>
<script>
import { mapState } from 'vuex';
export default {
  name: 'CommonHeader',
  props: {
    // 页面title
    title: {
      type: String,
      default: ''
    },
    // 页面使用说明  text展示文字    content主要内容
    explain: {
      type: Object,
      default: () => {
        return {};
      }
    },
    // 是否显示面包屑
    breadcrumbShow: {
      type: Boolean,
      default: true
    },
    // 页面 头部标签页  [{label:"",name:""}]
    tabsList: {
      type: Array,
      default: () => {
        return [];
      }
    },
    tabsQuantityShow: {
      type: Boolean,
      default: false
    },
    tabsDefault: {
      type: String,
      default: ''
    }
  },
  watch: {
    tabsDefault(val) {
      this.tabsActiveName = val;
    }
  },
  data() {
    return {
      tabsActiveName: '',
      dialogVisible: false,
      notificationList: []
    };
  },
  computed: {
    ...mapState([
      'menuCollapseFlag',
      'breadcrumbList'
    ])
    // isIncreaseFlag () {
    //   let buttonList = [];
    //   if (this.$slots.buttons && this.$slots.buttons.length > 0) {
    //     buttonList = this.$slots.buttons.filter(item => {
    //       return item.tag;
    //     });
    //   }
    //   return buttonList.length > 0 || this.tabsList.length > 1;
    // }
  },
  methods: {
    pageJump(data) {
      this.$router.push({
        path: data.path,
        query: data.query ? data.query : {}
      });
    },
    tabsClickHandler(val) {
      this.tabsActiveName = val.name;
      this.$emit('handleTabsClick', val);
    },
    showDialog() {
      this.dialogVisible = true;
    }
  },
  mounted() {
    if (this.tabsList.length > 0) {
      this.tabsActiveName = this.tabsDefault
        ? this.tabsDefault
        : this.tabsList[0].name;
    }
  }
};
</script>
<style lang="scss">
@import "@/style/common.scss";

.common_header {
  width: 100%;
  height: 50px;

  >.wrap {
    background: #ffffff;
    // box-shadow: 8px 6px 16px #EBEEF5;
    box-shadow: 4px 0 7px 0 rgb(0 0 0 / 12%);
    position: fixed;
    top: 58px;
    right: 0;
    left: 230px;
    z-index: 102;
    padding-left: 20px;
    padding-right: 16px;
    transition: left 0.3s ease-in-out;

    &.isCollapse {
      left: 64px;
    }

    >.top {
      height: 58px;
      line-height: 58px;
      overflow: hidden;
      @extend .clear;

      >.breadcrumb {
        float: left;
        color: #424C57;
        font-size: 16px;

        >.homeIcon {
          cursor: pointer;
        }

        >i {
          font-size: 18px;
        }

        >span {
          >i {
            margin: 0 10px;

            &:after {
              content: '>';
              display: inline;
            }
          }

          >span {
            cursor: pointer;
          }
        }
      }

      >.explain {
        float: left;
        margin-left: 18px;
        font-size: 14px;
        color: #424C57;

        >i {
          font-size: 16px;
          color: #14937b;
          margin-right: 6px;
        }

        >span {
          color: #14937b;
          cursor: pointer;
        }
      }

      >.buttons {
        float: right;

        >.el-button:first-child {
          background: #14937B;
          color: #FFFFFF;
          border-color: #14937B;

          &:hover {
            border-color: #14937B;
            background: #17A58A;
          }
        }
      }

      >.noticeBar {
        width: 400px;
        height: 58px;
        line-height: 58px;
        padding-right: 0;
        float: right;
      }
    }

    >.bottom {
      height: 70px;
      border-top: 1px solid #F0F1F2;
      position: relative;

      >.tabs {
        @extend .clear;
        position: absolute;
        bottom: 0;
        left: 0;

        >.tabsPane {
          float: left;
          padding: 16px 30px;
          color: #424C57;
          position: relative;
          overflow: hidden;
          transition: all .3s cubic-bezier(.645, .045, .355, 1);
          cursor: pointer;

          &:after,
          &:before {
            content: '';
            display: block;
            width: 50%;
            height: 4px;
            background: #14937B;
            position: absolute;
            top: 0;
            transition: all .3s cubic-bezier(.645, .045, .355, 1);
          }

          &:after {
            left: -50%;
          }

          &:before {
            right: -50%;
          }

          &>.tipsNum {
            width: 18px;
            height: 18px;
            display: flex;
            align-items: center;
            justify-content: center;
            box-sizing: content-box;
            background: #F56C6C;
            color: #FFFFFF;
            position: absolute;
            top: 6px;
            right: 8px;
            border-radius: 10px;
            font-size: 22px;

            &.widening {
              padding: 0 4px;
            }

            >span {
              display: inline-block;
              transform: scale(.5);
            }
          }
        }

        >.active {
          background: #E9ECF1;
          color: #202932;

          &:after {
            left: 0;
          }

          &:before {
            right: 0;
          }
        }
      }

      >.buttons {
        position: absolute;
        right: 0;
        bottom: 16px;

        >.el-button:first-child {
          background: #14937B;
          color: #FFFFFF;
          border-color: #14937B;

          &:hover {
            border-color: #14937B;
            background: #17A58A;
          }
        }
      }
    }
  }
}

.common_header_increase {
  height: 120px;

  >.wrap {
    height: 128px;
  }
}

.common_header_narrow {
  height: 70px;

  >.wrap {
    height: 70px;
  }
}

.ruleDialog .common_readonly_template .el-col .text {
  line-height: 28px !important;
  min-height: auto !important;
}
</style>
